import { useQuery } from "@tanstack/react-query";
import { fetchRawSnapshot } from "../mini_server";
import { LightUserUtils, ILightUser } from "../types/leanTypes/lightProfile";
import { queryKeys } from "../lib/queryKeys";
import { QUERY_TIERS } from "../lib/queryConfig";

export const useLightUserSnapshot = (
  address: string | null,
  customQueryKey?: any[],
  enabled?: boolean
) => {
  return useQuery<ILightUser>({
    queryKey: customQueryKey || queryKeys.lightUserSnapshot.byAddress(address!),
    queryFn: async () => {
      const rawData = await fetchRawSnapshot({ address: address! });
      return LightUserUtils.fromMap(rawData);
    },
    enabled: enabled ?? !!address,
    ...QUERY_TIERS.profile,
  });
};
